export default "__VITE_ASSET__0NaOEnzp__"